"use client";

import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";
import { SoftText } from "@/components/text/SoftText";

export function AudioExampleModule({
  heading,
  leftTitle,
  leftDescription,
  leftAudioSource,
  rightTitle,
  rightDescription,
  rightAudioSource,
  className,
}: {
  heading?: string;
  leftTitle: string;
  leftDescription: string;
  leftAudioSource: string;
  rightTitle: string;
  rightDescription: string;
  rightAudioSource: string;
  className?: string;
}) {
  return (
    <div className={className}>
      {heading !== undefined && (
        <Heading4 elementType="h3" className="mt-4">
          {heading}
        </Heading4>
      )}
      <div className="sm: mt-2 grid grid-cols-1 gap-x-8 sm:grid-cols-2">
        <div>
          <NormalText elementType="p">{leftTitle}</NormalText>
          <SoftText elementType="p">{leftDescription}</SoftText>
          <BigAudioPlayer
            source={leftAudioSource}
            includePreviewText={false}
            bigWaves={false}
            className="mt-2 rounded-3xl bg-gray-900/5 p-4"
            filename={null}
          />
        </div>
        <div className="w-full">
          <NormalText elementType="p">{rightTitle}</NormalText>
          <SoftText elementType="p">{rightDescription}</SoftText>
          <BigAudioPlayer
            source={rightAudioSource}
            includePreviewText={false}
            bigWaves={false}
            className="mt-2 rounded-3xl bg-gray-900/5 p-4"
            filename={null}
          />
        </div>
      </div>
    </div>
  );
}
